import { useId, type ReactNode } from 'react'

type PropsControl = { id: string; 'aria-invalid': boolean; 'aria-describedby'?: string }

type Props = {
  etiqueta: string
  /** Texto de apoyo bajo el control (formato, qué pasa después de guardar). */
  ayuda?: string
  /** Mensaje de error ya redactado: qué pasó y cómo resolverlo. */
  error?: string
  children: (control: PropsControl) => ReactNode
}

/**
 * Campo de formulario con etiqueta visible, ayuda y error asociados al control (WCAG 1.3.1 y 3.3.1).
 * El control se pasa como función para recibir `id`, `aria-invalid` y `aria-describedby`.
 */
export function Campo({ etiqueta, ayuda, error, children }: Props) {
  const id = useId()
  const describe = [ayuda ? `${id}-ayuda` : null, error ? `${id}-error` : null].filter(Boolean).join(' ')
  return (
    <div className="campo">
      <label htmlFor={id}>{etiqueta}</label>
      {children({ id, 'aria-invalid': Boolean(error), 'aria-describedby': describe || undefined })}
      {ayuda && (
        <p id={`${id}-ayuda`} className="campo__ayuda">
          {ayuda}
        </p>
      )}
      {error && (
        <p id={`${id}-error`} className="campo__error" role="alert">
          {error}
        </p>
      )}
    </div>
  )
}
